import { EuiConfirmModal } from "@inscopix/ideas-eui";
import { useState } from "react";

interface ModalCreateTestTableProps {
  closeModal: () => void;
  createTable: () => Promise<void>;
}
export const ModalCreateTestTable = ({
  closeModal,
  createTable,
}: ModalCreateTestTableProps) => {
  const [loading, setLoading] = useState(false);

  const handleCreateTestTable = async () => {
    setLoading(true);
    await createTable();
    setLoading(false);
  };
  return (
    <EuiConfirmModal
      title="Are you sure you wish to proceed?"
      confirmButtonText="Create New Test Table"
      cancelButtonText="Cancel"
      onCancel={closeModal}
      onConfirm={() => void handleCreateTestTable()}
      isLoading={loading}
    >
      Creating a new test table will overwrite the existing one. Do you want to
      proceed?
    </EuiConfirmModal>
  );
};
